<template>
  <div class="stepper-box">
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>

    <b-card>
      <b-row>
        <b-col xl="6" md="6" sm="12">
          <span class="f-g">
            <h3 v-if="!haveJornalzinhos">
              Você não possui jornalzinhos ativos
            </h3>
            <h3 v-else-if="haveJornalzinhos == 1">
              Você possui {{ numJornalzinhos }} jornalzinho ativo
            </h3>
            <h3 v-else>
              Você possui {{ numJornalzinhos }} jornalzinhos ativos
            </h3>
          </span>
        </b-col>
        <b-col xl="6" md="6" sm="12">
          <div>
            <b-button
              variant="success"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              @click="createJornalzinho"
            >
              <i class="fa fa-plus fa-xl"></i>
              Adicionar jornalzinho
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="text-center f-g" v-if="!haveJornalzinhos">
      <i class="fa fa-frown-o fa-custom-size"></i>
      <h4>Desculpe, não encontramos nenhum jornalzinho :(</h4>
      <h5>Para adicionar, clique no botão acima e comece as integrações!</h5>
    </b-card>

    <b-card
      class="text-center mt-3"
      v-if="haveJornalzinhos"
      style="font-size: 15px"
    >
      <b-table
        id="tableJornalzinhos"
        :items="jornalzinhos"
        :fields="fields"
        striped
        bordered
        hover
        responsive
        stickyColumns="true"
        class="mb-0"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(urlimagem)="data">
          <img
            v-if="data.item.urlimagem"
            :src="data.item.urlimagem"
            alt="Thumbnail"
            style="height: 100px"
          />
          <span v-else>Sem imagem</span>
        </template>

        <template v-slot:cell(showText)="data">
          <b-badge
            v-if="data.item.showText == false"
            variant="danger"
            style="font-size: 15px"
          >
            {{ data.item.showText == false ? "Não" : "Sim" }}
          </b-badge>
          <b-badge v-else variant="success">
            {{ data.item.showText == false ? "Não" : "Sim" }}
          </b-badge>
        </template>
      </b-table>
    </b-card>

    <b-modal
      ref="modalJornalzinho"
      size="lg"
      centered
      hide-footer
      :title="titleJornalzinho"
    >
      <b-row>
        <b-col cols="4" @click="reenviarCampanha(idJornalzinho)">
          <b-col cols="12" class="centerModal">
            <i
              class="fa fa-share-square-o fa-custom-size"
              aria-hidden="true"
            ></i>
            <span>
              Reenviar
              <br />Campanha
            </span>
          </b-col>
        </b-col>
        <b-col cols="4" @click="editarJornalzinho(idJornalzinho)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-edit fa-custom-size" aria-hidden="true"></i>
            <span>
              Editar Imagens
              <br />Jornalzinho
            </span>
          </b-col>
        </b-col>
        <b-col cols="4" @click="excluirJornalzinho(idJornalzinho)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-times fa-custom-size" aria-hidden="true"></i>
            <span>
              Excluir
              <br />Jornalzinho
            </span>
          </b-col>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import axios from "axios";

import * as config from "@/config.json";

export default {
  name: "jornalzinho",
  components: {
    Loading,
  },

  data() {
    return {
      isLoading: false,
      jornalzinhos: [],
      fields: [
        { key: "urlimagem", label: "Imagem" },
        { key: "id", label: "Id" },
        { key: "titulo", label: "Título" },
        { key: "descricao", label: "Descrição" },
        { key: "data_inicial", label: "Início", sortable: true },
        { key: "data_final", label: "Fim", sortable: true },
      ],
      haveJornalzinhos: false,
      numJornalzinhos: 0,
      titleJornalzinho: "",
      descriptionJornalzinho: "",
      idJornalzinho: "",
      urlImagemJonalzinho: "",
    };
  },

  methods: {
    async getJornalzinhos() {
      this.isLoading = true;

      const url = `${
        config.default.servidor
      }/gerencial/jornalzinho/ativo/${localStorage.getItem("enterprise_id")}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.jornalzinhos = response.data.data;

          if (this.jornalzinhos.length > 0) {
            this.haveJornalzinhos = true;
            this.numJornalzinhos = this.jornalzinhos.length;
          } else {
            this.haveJornalzinhos = false;
            this.numJornalzinhos = 0;
          }

          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async createJornalzinho() {
      this.isLoading = true;
      this.$router.push("jornalzinho/inserirJornalzinho");
      this.isLoading = false;
    },

    async rowClicked(jornal) {
      this.titleJornalzinho = jornal.titulo;
      this.descriptionJornalzinho = jornal.descricao;
      this.idJornalzinho = jornal.id;
      this.urlImagemJonalzinho = jornal.urlimagem;

      await this.openModal("modalJornalzinho");
    },

    openModal(modal) {
      this.$refs[modal].show();
    },

    reenviarCampanha(id) {
      localStorage.setItem("id", id);
      localStorage.setItem("isPromocao", "true");
      localStorage.setItem("tituloJornalzinho", this.titleJornalzinho);
      localStorage.setItem("descricaoJornalzinho", this.descriptionJornalzinho);
      localStorage.setItem("tipoid", "1");

      this.$router.push("cadastrar-campanha");
    },

    async editarJornalzinho(url) {
      localStorage.setItem("url_imagem", url);
      localStorage.setItem("titulo_promocao", this.titleJornalzinho);
      localStorage.setItem("id_promocao", this.idJornalzinho);

      await this.$router.push({
        path: "promocoes/editar-imagem-jornalzinho",
      });
    },

    excluirJornalzinho(id) {
      this.$refs.modalJornalzinho.hide();

      this.$swal({
        title: "Jornalzinho",
        text: "Confirma desvincular este jornalzinho do app?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((res) => {
        if (res.value) {
          this.deleteJornalzinho(id);
        }
      });
    },

    async deleteJornalzinho(id) {
      const url = `${config.default.servidor}/gerencial/jornalzinho/${id}`;
      try {
        const response = await axios({
          url,
          method: "delete",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.status == 200) {
          this.$alert("O jornalzinho foi excluído!", "Sucesso", "success");

          await this.getJornalzinhos();
        }
      } catch (error) {
        console.log({ error });
        this.$alert("Erro ao excluir o jornalzinho!", "Erro", "error");
      }
    },
  },

  async beforeMount() {
    this.isLoading = true;
    await this.getJornalzinhos();
    this.isLoading = false;
  },
};
</script>

<style src="./jornalzinho.scss" scoped lang="scss">